

import transitionCheckout from '@/apollo/queries/transition-checkout/transition-checkout'
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [productInsuranceNameMixins],
  data() {
    return {
      pages: {
        type: Object,
        default: () => { },
      },
      productCat: {
        type: Object,
        default: () => { },
      },
      productCats: {
        type: Object,
        default: () => { },
      },
      loading: 0,
      dataReady: false,
    };
  },

  head() {
    return {
      title: this.firstSubcatObj?.PageMeta?.Title,
      meta: [
        {
          hid: 'og:title', name: 'og:title', property: 'og:title',
          content: this.firstSubcatObj?.PageMeta?.Title,
        },
        {
          hid: 'og:description', name: 'og:description', property: 'og:description',
          content: this.firstSubcatObj?.PageMeta?.Description,
        },
        {
          hid: 'description', name: 'description',
          content: this.firstSubcatObj?.PageMeta?.Description,
        },
        {
          hid: 'og:image', name: 'og:image', property: 'og:image',
          content: this.firstSubcatObj?.PageMeta?.Image?.url,
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ]
    }
  },

  computed: {
    insurerTranslations() {
      return this.getCheckoutTranslations(this.transitionCheckoutData?.insuranceCompanies[0].insurance_company_translations[0].localizations)[0];
    }
  },

  mounted() {
  },

  methods: {
    openLink(url) {
      window.location.replace(url);
    },
  },

  watch: {
    transitionCheckoutData(newValue, oldValue) {
      if (newValue !== oldValue) {
        console.debug('transitionCheckoutData changed...')
        const that = this

        if (
          !this.transitionCheckoutData ||
          !this.transitionCheckoutData?.insuranceCompanies.length ||
          !this.transitionCheckoutData?.blogDisclaimers.length) {
          console.error('Data missing:','Please check the insurer code.')
          this.$sentry.captureMessage('Data missing - Please check the insurer code.', 'warning');
          console.debug('insuranceCompanies length:', this.transitionCheckoutData?.insuranceCompanies.length)
          console.debug('blogDisclaimers length ', this.transitionCheckoutData?.blogDisclaimers.length)
        } else {
          setTimeout(function () {
            if (that.$route?.query?.link) {
              const decodedLink = decodeURIComponent(that.$route.query.link);
              that.openLink(decodedLink);
            }
          }, 3000)
        }

      }
    }
  },

  apollo: {
    $loadingKey: "loading",
    transitionCheckoutData: {
      prefetch: false,
      query: transitionCheckout,
      variables() {
        return {
          currentlocale: this.$normalizeLocale(this.$i18n.locale),
          currentI18NLocaleCode: this.$normalizeLocale(this.$i18n.locale),
          insurerCode: this.$route.query.insurer,
          disclaimerType: 'transition-checkout-bottom'
        };
      },
      update(data) {
        return this.$normalizeStrapi(data);
      },
    },
  },
}
